import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import env from "../../../utils/env";
import "./Footer.css";

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavScroll = (section) => {
    if (location.pathname === "/") {
      // Already on home, scroll
      const el = document.getElementById(section);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { scrollTo: section } });
    }
  };



  return (
    <>
      <footer className="py-5 text-center border-top border-white border-opacity-10">
        <div className="container">
          <h3 className="fw-bold mb-4">Land your dream job with AI</h3>
          <a href={env.API_ASSETS_URL + "WindowsTransformSetup.exe"} target="_blank" rel="noopener noreferrer" style={{textDecoration: "none"}}>
            <button
              className="btn btn-primary rounded-pill px-5 py-2 fw-bold"
            >
              Download for Windows
            </button>
          </a>
        </div>
      </footer>
      <footer className="py-5 border-top border-white border-opacity-10 mt-5 bg-dark bg-opacity-25">
        <div className="container">
          <div className="row g-4 text-center text-md-start">
            {/* Section 1: Quick Links */}
            <div className="col-12 col-md-4">
              <h5 className="fw-bold mb-4 text-white">Quick Links</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <Link
                    to="/"
                    className="text-secondary text-decoration-none hover-white"
                  >
                    Home
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/contact"
                    className="text-secondary text-decoration-none"
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Section 2: Contact Us */}
            <div className="col-12 col-md-4">
              <h5 className="fw-bold mb-4 text-white">Contact Us</h5>
              <p className="text-secondary small mb-2">
                <i className="fas fa-envelope me-2 text-primary"></i>
                info@interviewsupport-ai.com
              </p>
              <p className="text-secondary small mb-2">
                <i className="fas fa-clock me-2 text-primary"></i>
                Phone: +1 909-235-9247
              </p>
            </div>

            {/* Section 3: Social Icons & CTA */}
            <div className="col-12 col-md-4 text-center text-md-end">
              <h5 className="fw-bold mb-4 text-white">Follow Us</h5>
              <div className="d-flex justify-content-center justify-content-md-end gap-3 mb-4">
                <a href="https://www.facebook.com/interviewsupportai" target="_blank" rel="noreferrer" className="text-secondary fs-4 hover-primary">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a

                  href="https://www.youtube.com/channel/UCh3HLuGLeJAn2XO8RWCfKSQ"
                  target="_blank"
                  rel="noreferrer"
                  className="text-secondary fs-4 hover-primary"
                >
                  <i className="fab fa-youtube"></i>
                </a>
                <a
                  href="https://wa.me/16576307025?text=InterviewSupportAI"
                  target="_blank"
                  rel="noreferrer"
                  className="text-secondary fs-4 hover-primary"
                >
                  <i className="fab fa-whatsapp"></i>
                </a>
                <a href="https://x.com/InterviewsuppAI" className="text-secondary fs-4 hover-primary">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="https://www.linkedin.com/company/interviewsupport-ai/" className="text-secondary fs-4 hover-primary">
                  <i className="fab fa-linkedin"></i>
                </a>
                <a href="https://www.instagram.com/interviewsupportai/" className="text-secondary fs-4 hover-primary">
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
              <p className="text-secondary small">
                Join 42k+ members in our community.
              </p>
            </div>
          </div>

          {/* Bottom Copyright Section */}
          <hr className="my-5 border-white border-opacity-10" />

          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-start">
              <h3 className="fw-bold mb-0 fs-5 text-white">
                InterviewSupport<span className="text-primary">-AI</span>
              </h3>
              <p className="mt-2 text-secondary small mb-0">
                &copy; 2025 InterviewSupport-AI. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end mt-3 mt-md-0">
              <span className="text-secondary x-small">
                Built for Windows 11+
              </span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
